import moment from 'moment';
import newhttp from '~/http/new';
import storeUtils from '~/utils/storeUtils';

export default ({
  state: {
    statistics: [],
    page: 1,
    pages: 0,
    filters: {},
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        page,
        filters,
      } = state;

      const itemsPerPage = rootGetters['common/itemsPerPage'];

      const filteredFilters = storeUtils.clearEmptyParams(filters);

      const { ...rest } = filteredFilters;

      return {
        ...rest,
        fromDate: filters.fromDate ? moment.utc(filters.fromDate).unix() : undefined,
        toDate: filters.toDate ? moment.utc(filters.toDate).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_SORT(state, data) { state.sort = data; },

    SET_STATISTICS(state, data) {
      state.statistics = data;
    },
  },

  actions: {
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },

    async loadTraderLeadReferrals({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await newhttp.get('v1/p2p/trader-lead-referrals', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { statistics, totalCount } = response.data;
      commit('SET_STATISTICS', statistics);
      if (totalCount) {
        const pages = Math.ceil(totalCount / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },
  },

  namespaced: true,
});
